// WalletView.jsx
import React, { useState } from 'react';
import './WalletView.css';

export default function WalletView({ availableBalance = 0 }) {
  // Datos de gasto por mes
  const spendData = [
    { label: 'Jan', value: 200 },
    { label: 'Feb', value: 150 },
    { label: 'Mar', value: 500 },
    { label: 'Apr', value: 300 },
    { label: 'May', value: 0 },
    { label: 'Jun', value: 120 },
    { label: 'Jul', value: 180 },
    { label: 'Aug', value: 220 },
    { label: 'Sep', value: 340 },
    { label: 'Oct', value: 410 },
    { label: 'Nov', value: 260 },
    { label: 'Dec', value: 180 },
  ];

  // Estado para el filtro
  const [filterMonth, setFilterMonth] = useState('');

  // Filtrar transacciones (aquí podrías reemplazar con datos reales)
  const transactions = [];
  const filtered = filterMonth
    ? transactions.filter(tx => tx.date.startsWith(filterMonth))
    : transactions;

  // Cálculos generales de gasto
  const maxValue   = Math.max(...spendData.map(d => d.value), 1);
  const totalSpend = spendData.reduce((sum, d) => sum + d.value, 0);

  // Parámetros de paginación: 6 barras por página
  const PAGE_SIZE = 6;
  const pageCount = Math.ceil(spendData.length / PAGE_SIZE);
  const [page, setPage] = useState(0);
  const displayedData = spendData.slice(
    page * PAGE_SIZE,
    page * PAGE_SIZE + PAGE_SIZE
  );

  const goPrev = () => setPage(p => Math.max(p - 1, 0));
  const goNext = () => setPage(p => Math.min(p + 1, pageCount - 1));

  return (
    <div className="wallet-container">
      <h1 className="wallet-title">Wallet</h1>

      {/* ---- Budget y Balance ---- */}
      <div className="wallet-grid">
        <div className="wallet-card budget">
          <p className="wallet-section-title">March Budget</p>
          <p className="wallet-amount">$500 / $2500</p>
          <div className="wallet-progress-bar">
            <div className="wallet-progress-fill" style={{ width: '20%' }} />
          </div>
          <button className="wallet-edit-btn">Edit budget</button>
        </div>

        <div className="wallet-card balance">
          <p className="wallet-section-title">Available Balance</p>
          <p className="wallet-balance">2500</p>
          <p className="wallet-subtext">Zenit Coins</p>
          <button className="wallet-getmore-btn">GET MORE</button>
        </div>
      </div>

      {/* ---- Gráfico de barras paginado ---- */}
      <div className="wallet-card spend">
        <p className="wallet-section-title">
          Total Spend <span className="wallet-spend-amount">{totalSpend} 🪙</span>
        </p>
        <div className="custom-bar-chart-container">
          <button
            className="chart-nav prev"
            onClick={goPrev}
            disabled={page === 0}
            aria-label="Anterior"
          >
            ‹
          </button>

          <div className="custom-bar-chart">
            <div className="chart-year">2025</div>

            {displayedData.map(item => {
              const percent    = (item.value / maxValue) * 100;
              const isZero     = item.value === 0;
              const isSelected = item.value === maxValue;
              return (
                <div key={item.label} className="bar-wrapper">
                  <div
                    className={`bar ${isZero ? 'zero' : ''} ${isSelected ? 'selected' : ''}`}
                    style={{ height: `calc(${percent}% + 0px)` }}
                  >
                    {!isZero && <span className="bar-value">{item.value}</span>}
                  </div>
                  <div className="bar-label">{item.label}</div>
                </div>
              );
            })}

          </div>

          <button
            className="chart-nav next"
            onClick={goNext}
            disabled={page === pageCount - 1}
            aria-label="Siguiente"
          >
            ›
          </button>
        </div>
      </div>

      {/* ---- Historial de transacciones ---- */}
      <div className="wallet-history">
        <h2 className="wallet-history-title">Transactions History</h2>
        <hr className="wallet-divider" />

        <div className="wallet-history-table">
          <div className="wallet-filter-row">
            <label htmlFor="monthFilter">Filter by month</label>
            <select
              id="monthFilter"
              value={filterMonth}
              onChange={e => setFilterMonth(e.target.value)}
            >
              <option value="">All</option>
              {spendData.map(d => (
                <option key={d.label} value={d.label}>
                  {d.label}
                </option>
              ))}
            </select>
          </div>

          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length > 0 ? (
                filtered.map((tx, i) => (
                  <tr key={i}>
                    <td>{tx.date}</td>
                    <td>{tx.description}</td>
                    <td>{tx.amount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="wallet-placeholder-row">
                    No data available yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}